import { MOCK_FORMS_DETAILS } from '@features/forms/constants/mockApiData';
import { FormDetail } from '@features/forms/types';
import { FormOverviewApiResponse } from '@features/forms/types/formOverviewApi';

const mapFormDetailToMockOverviewApi = (
  detail: FormDetail
): FormOverviewApiResponse => ({
  id: detail.id,
  name: detail.name,
  status: detail.status,
  image_url: detail.coverImageUrl ?? '',
  description: detail.description ?? '',
  version: detail.formVersion,
  add_to_mode: detail.addTo.mode,
  group: {
    id: detail.addTo.groupId ?? '',
    name: detail.addTo.groupName ?? ''
  },
  form_link: detail.publicUrl,
  fee_amount: detail.feeAmount,
  is_partial_payment_enabled: detail.acceptInstallments ?? false,
  min_partial_payment_amount: 0,
  discount_config: {
    is_enabled: Boolean(detail.discountType),
    type: detail.discountType ?? 'percentage',
    value: detail.discountValue ?? 0
  },
  registration_max_count: detail.submissionCap ?? 0,
  registration_end_time: detail.autoCloseDate ?? null,
  start_collection_from: detail.startCollectionFrom ?? 'same_month',
  is_source_tracking_enabled: detail.sourceTrackingEnabled,
  form_fields: detail.fields.map((field) => ({
    id: field.id,
    name: field.label,
    type: String(field.type),
    is_required: field.required,
    display_order: field.order,
    options: field.options ?? [],
    sync_to_member: field.syncToMember ?? false
  })),
  total_registrations: detail.totalRegistrations ?? 0,
  total_revenue: detail.totalRevenue ?? 0,
  total_view: detail.viewCount,
  total_discount: detail.totalDiscount ?? 0,
  conversion_rate: String(detail.conversionRate),
  conversion_breakdown: {
    viewed_count:
      detail.registrationPerformance?.views.count ?? detail.viewCount,
    form_submitted_count:
      detail.registrationPerformance?.formSubmitted.count ?? 0,
    mobile_verified_count:
      detail.registrationPerformance?.mobileVerified.count ?? 0,
    paid_count:
      detail.registrationPerformance?.paid.count ?? detail.registrationCount
  },
  source_breakdown: (detail.sourceBreakdown ?? []).map((row) => ({
    source: row.source,
    viewed_count: row.views,
    paid_count: row.paid,
    conversion_rate: String(
      row.convRate > 1 ? row.convRate / 100 : row.convRate
    )
  })),
  created_at: detail.createdAt ?? detail.lastEdited,
  updated_at: detail.lastEdited
});

export const getMockFormOverviewApi = (
  formId: string
): FormOverviewApiResponse | undefined => {
  const detail = MOCK_FORMS_DETAILS[formId];
  if (!detail) {
    return undefined;
  }
  return mapFormDetailToMockOverviewApi(detail);
};

export default getMockFormOverviewApi;
